import { render } from "./ConfEmail.vue?vue&type=template&id=241017ec"
import script from "./ConfEmail.vue?vue&type=script&lang=js"
export * from "./ConfEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__